








import { watch, defineComponent, computed } from "@vue/composition-api";
import Explorer from "@/components/Explorer.vue";
import Reader from "@/components/Reader.vue";
import { infoStore } from "@/store/infoStore";
import { routerStore } from "@/store/routerStore";

export default defineComponent({
  components: {
    Explorer,
    Reader,
  },
  setup() {
    
    const isFile = computed(()=> {
      const manifest = infoStore.getState().manifest;
      const pathList = Object.keys(manifest)
      return pathList.includes(routerStore.pwd)
    })
    return {
      isFile
    };
  }
});
